import { Line } from 'react-chartjs-2';

function LineChart(props) {
    const {stats_data, wanted_data} = props;

    let datasets = [];
    let colors = ['','#155ba3', '#aec7e8', '#ff7f0e', '#ffbb78', '#70bf70'];
    
    Object.keys(stats_data).forEach((key, index) => {
        if(key !== 'date') {
        datasets.push({
            label: wanted_data[key],
            data: stats_data[key],
            fill: false,
            backgroundColor: colors[index],
            borderColor:  colors[index],
            borderWidth: 2
        })
        }
    })

    const data = {
        labels: stats_data.date,
        datasets: datasets
    };

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
            x: {
                ticks: {
                    maxTicksLimit: 5
                }
            },
            y: {
                min: 0
            }
        },
        elements: {
            point: {
                radius: 0
            }
        },
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth: 8
                },
                onHover: function (e) {
                    e.native.target.style.cursor = 'pointer'
                },
            },
        },
        tooltips: {
            mode: 'nearest',
            intersect: false,
        },
        hover: {
            mode: 'nearest',
            intersect: false
        },
        onHover: function (e) {
            e.native.target.style.cursor = 'pointer'
        },

    }

    return(
        <Line data={data} options={options} className="linechart"/>
    )
}
export default LineChart;